import { render, staticRenderFns } from "./deanIcon.vue?vue&type=template&id=4e92b8dc&scoped=true"
import script from "./deanIcon.vue?vue&type=script&lang=ts"
export * from "./deanIcon.vue?vue&type=script&lang=ts"
import style0 from "./deanIcon.vue?vue&type=style&index=0&id=4e92b8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92b8dc",
  null
  
)

export default component.exports